import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import {
  DISABLE_PARTNER_AUTO_LOGIN,
  PARTNER_PORTAL,
} from '@constants/storageKeys';
import { SnackbarVariant, useSnackbar } from '@hooks/useSnackbar';
import { getBaseUrl } from '@services/Auth/utils';
import { useUserRole } from '@utils/useUserRole';

const useAuthRedirect = () => {
  const snackbar = useSnackbar();
  const { isPartner, loading } = useUserRole();

  useEffect(() => {
    if (loading || isPartner) return;

    if (window.sessionStorage.getItem(DISABLE_PARTNER_AUTO_LOGIN) === 'true') {
      return;
    }

    const rawPortalToken = window.localStorage.getItem(PARTNER_PORTAL);
    if (!rawPortalToken) return;

    try {
      const parsed = JSON.parse(rawPortalToken);

      if (Object.keys(parsed).length > 0) {
        window.location.href = `${getBaseUrl()}/auth/okta/external/login`;
        return;
      }
    } catch (e) {
      Sentry.captureException(
        new Error(
          `Failed to parse partner-portal token from localStorage: ${e}`
        )
      );

      snackbar({
        message:
          'We could not read your partner portal info. Please check that you are logged into the portal and try again.',
        variant: SnackbarVariant.Error,
        preventDuplicate: true,
      });
    }
  }, [snackbar, isPartner, loading]);
};
export { useAuthRedirect };
